export default __webpack_public_path__ + "static/techguru-example5-944bf3538adf3fd5480a80fe804b1219.jpg";